import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { MiniFeatures } from 'owa-mini-feature-flags/lib/isMiniFeatureEnabled';
const isWebPushNotificationSupported = (windowObj: Window) => {
    if (!isMiniFeatureEnabled('mini-push-notification-mail' as MiniFeatures)) {
        return false;
    }
    return (
        'navigator' in windowObj &&
        'serviceWorker' in windowObj.navigator &&
        'PushManager' in windowObj
    );
};
export default isWebPushNotificationSupported;
